/**
 * @license
 * Copyright© Celligence International, LLC - 2023
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
*/
import React, { useState, useEffect, lazy } from 'react';
import { Spinner } from "react-bootstrap";
import { dragElement } from '../Utils/helpers';
import ReactPlayer from 'react-player/lazy'

const ReactPlayerWrapper = ({
    width, height, url, latestLoadingUpdate, deviceType
}) => {

    console.log("url",url)

    const [isLoading, setIsLoading] = useState(false)
    const [reactPlayerClassName, setreactPlayerClassName] = useState(``)
    const [isPlaying, setIsPlaying] = useState(false)
    const [iframeError, showIframeError] = useState(false)

    const detectLongTouch = () => {
        var onlongtouch; 
        var timer;
        var touchduration = 800; //length of time we want the user to touch before we do something

        function touchstart(e) {
            e.preventDefault();
            if (!timer) {
                timer = setTimeout(onlongtouch, touchduration);
            }
        }

        function touchend() {
            //stops short touches from firing the event
            if (timer) {
                clearTimeout(timer);
                timer = null;
            }
        }

        onlongtouch = function () {
            timer = null;
            dragElement(document.getElementById("draggable"));
        };

        document.addEventListener("DOMContentLoaded", function(event) { 
            window.addEventListener("touchstart", touchstart, false);
            window.addEventListener("touchend", touchend, false);
        });
    }

    useEffect(() => {
        setIsLoading(true)
        showIframeError(false)
        setreactPlayerClassName(`react-player-class-container loader-present`)

        /** handles drag of modal */
        dragElement(document.getElementById("draggable"));

        if(deviceType && deviceType === 'mobile') {
            detectLongTouch()
        }
    }, [])

    useEffect(() => {
        !isLoading && setreactPlayerClassName(`react-player-class-container`)
        isLoading && setreactPlayerClassName(`react-player-class-container loader-present`)

        /** send loader variable updates back to parent, for css use */
        latestLoadingUpdate(isLoading)

    }, [isLoading])

    /** COmmented as of now */
    // useEffect(() => {
    //     // Loader for 10s only, because atmost slow 3g completely loads youtube iframe within 10s
    //     if (isLoading) {
    //         setTimeout(() => {

    //             /** If video playing has nt started yet */
    //             if (!isPlaying) {
    //                 // Remove loader and show error div
    //                 setIsLoading(false)
    //                 showIframeError(true)
    //             }

    //         }, 10000);
    //     }

    // }, [isLoading])

    return (
        <>
            {isLoading && <Spinner className="fallback-react-player" animation="border" variant="primary" />}
            
            {reactPlayerClassName && <ReactPlayer
                className={reactPlayerClassName}
                width={'inherit'}
                height={'inherit'}
                url={url}
                muted={true} // chrome supposrts muted videos only to be autoplayed
                playing={true}
                controls={true}
                onReady={() => setIsLoading(false)}
                onPlay={() => {
                    setIsLoading(false)
                    setIsLoading(false)
                }}
            />}
        </>
    );
}

export default ReactPlayerWrapper;